import {ALERT_CLUSTER_LAYER_ID, ALERT_LAYER_ID, PERSON_DETAIL_LAYER_ID_GLOBAL} from '../map';

/**
 * LAYER IDs Match and provided by GIS team and must match
 */
const NON_MAP_AFFECTED_PEOPLE_AT_SITES_LAYER_ID = 'affected_people_at_sites';

export const ALERT_DETAIL_LINES_LAYER_ID = 'Alert-lines';
export const ALERT_DETAIL_POINTS_LAYER_ID = 'alerts-points';
export const ALERT_DETAIL_POLYGONS_LAYER_ID = 'alert_polygon';
export const NON_MAP_AFFECTED_PEOPLE_LAYER_ID = 'affected_people';
export const NON_MAP_AFFECTED_SITES_LAYER_ID = 'affected_sites';
/**
 * The end.
 */

const THREAT_ZONE_CITY_DETAIL_LAYER_ID = 'threat-zone-city-detail-layer-boundary';
const THREAT_ZONE_COUNTRY_DETAIL_LAYER_ID = 'threat-zone-country-detail-layer-boundary';
const THREAT_ZONE_PROVINCE_DETAIL_LAYER_ID = 'threat-zone-province-detail-layer-boundary';

export const CRISIS_SIGNAL_LAYER_ID = 'crisis-signal-layer';

export const PERSON_DETAIL_LAYER_ID = PERSON_DETAIL_LAYER_ID_GLOBAL;
export const PERSON_LAYER_ID = 'person-layer';

export const POLYGON_BOUNDS_LAYER = 'polygon-manager-bounds-layer';
export const POLYGON_SELECTION_LAYER = 'polygon-manager-selection-layer';

export const RATINGS_CITY_LAYER_BOUNDARY_ID = 'ratings-city-layer-boundary';
export const RATINGS_CITY_LAYER_POINT_ID = 'ratings-city-layer-point';
export const RATINGS_COUNTRY_LAYER_ID = 'ratings-country-layer';
export const RATINGS_COUNTRY_SOURCE_ID = 'ratings-country-source';
export const RATINGS_PROVINCE_LAYER_ID = 'ratings-province-layer';

export const SITE_DETAILS_LAYER_ID = 'site-details-layer';
export const SITE_LAYER_ID = 'site-layer';

export const THREAT_ZONE_CITY_DETAIL_SOURCE_BOUNDARY_ID = 'threat-zone-city-detail-source-boundary';
export const THREAT_ZONE_CITY_LAYER_ID = 'threat-zone-city-layer-boundary';
export const THREAT_ZONE_COUNTRY_DETAIL_SOURCE_BOUNDARY_ID = 'threat-zone-country-detail-source-boundary';
export const THREAT_ZONE_COUNTRY_LAYER_ID = 'threat-zone-country-layer-boundary';
export const THREAT_ZONE_LAYER_ID = 'threat-zone-layer-boundary';
export const THREAT_ZONE_PROVINCE_DETAIL_SOURCE_BOUNDARY_ID = 'threat-zone-province-detail-source-boundary';
export const THREAT_ZONE_PROVINCE_LAYER_ID = 'threat-zone-province-layer-boundary';

export const ALERT_LAYERS = [ALERT_LAYER_ID, ALERT_CLUSTER_LAYER_ID];

export const CAMERA_LAYER_ID = 'camera-layer';
export const CAMERA_DETAIL_LAYER_ID = 'camera-detail-layer';
export const ALARM_LAYER_ID = 'alarm-layer';
export const ALARM_DETAIL_LAYER_ID = 'alarm-detail-layer';

export const LAYERS = {
  ALERT_CLUSTER_LAYER_ID,
  ALERT_DETAIL_LINES_LAYER_ID,
  ALERT_DETAIL_POINTS_LAYER_ID,
  ALERT_DETAIL_POLYGONS_LAYER_ID,
  ALERT_LAYER_ID,
  CRISIS_SIGNAL_LAYER_ID,
  NON_MAP_AFFECTED_PEOPLE_AT_SITES_LAYER_ID,
  NON_MAP_AFFECTED_PEOPLE_LAYER_ID,
  NON_MAP_AFFECTED_SITES_LAYER_ID,
  PERSON_DETAIL_LAYER_ID,
  PERSON_LAYER_ID,
  POLYGON_BOUNDS_LAYER,
  POLYGON_SELECTION_LAYER,
  RATINGS_CITY_LAYER_BOUNDARY_ID,
  RATINGS_CITY_LAYER_POINT_ID,
  RATINGS_COUNTRY_LAYER_ID,
  RATINGS_PROVINCE_LAYER_ID,
  SITE_DETAILS_LAYER_ID,
  SITE_LAYER_ID,
  THREAT_ZONE_CITY_DETAIL_LAYER_ID,
  THREAT_ZONE_CITY_LAYER_ID,
  THREAT_ZONE_COUNTRY_DETAIL_LAYER_ID,
  THREAT_ZONE_COUNTRY_LAYER_ID,
  THREAT_ZONE_LAYER_ID,
  THREAT_ZONE_PROVINCE_DETAIL_LAYER_ID,
  THREAT_ZONE_PROVINCE_LAYER_ID,
  CAMERA_LAYER_ID,
  CAMERA_DETAIL_LAYER_ID,
  ALARM_LAYER_ID,
  ALARM_DETAIL_LAYER_ID,
};
